import { LEGACY_KEYS } from './legacy-workspace-reader.js'

function parse(value, fallback) {
  if (value == null || value === '') return fallback
  try { return JSON.parse(value) } catch { return fallback }
}

export function createLegacyDataRepository({ storage = globalThis.localStorage } = {}) {
  const read = (key, fallback) => parse(storage?.getItem?.(key), fallback)
  const write = (key, value) => storage?.setItem?.(key, JSON.stringify(value))
  return {
    config: { load: () => read(LEGACY_KEYS.config, {}), save: (value) => write(LEGACY_KEYS.config, value) },
    prompts: { load: () => read(LEGACY_KEYS.prompts, []), save: (value) => write(LEGACY_KEYS.prompts, Array.isArray(value) ? value : []) },
    groups: { load: () => ({ groups: read(LEGACY_KEYS.groups, []), groupGroups: read(LEGACY_KEYS.groupGroups, []) }), save: (value) => { write(LEGACY_KEYS.groups, value?.groups || []); write(LEGACY_KEYS.groupGroups, value?.groupGroups || []) } },
    outputs: { load: () => read(LEGACY_KEYS.outputs, []), save: (value) => write(LEGACY_KEYS.outputs, Array.isArray(value) ? value : []) },
  }
}
